import React, { Fragment } from 'react';

import './RecurringBuyFundEditor.scss';

import RetailContributionsEditor from '../../Buy/BuyFlow/RetailContributionsEditor/RetailContributionsEditor';
import { IRA_CONTRIBUTIONS_MODAL } from '../../../redux/modules/modals/modals.module';
import If from '../../Shared/If/If';
import { isIRA } from '../../../utils/IRA/IRA-utility';
import { isRAS } from '../../../utils/advice/advice-utility';
import DepositsInformationTooltip from '../../Buy/BuyFlow/DepositsInformationNote/DepositsInformationTooltip';

const RecurringBuyFundEditorWrapper = (props) => {
  const {
    actions: { openModal },
    fund,
    MonthGrid,
    DayGrid,
  } = props;

  function showIRAContributions() {
    openModal(IRA_CONTRIBUTIONS_MODAL, {
      showSelectedYearOnlySmallVP: true,
      fund,
    });
  }
  return (
    <Fragment>
      <div className="rb-fund-editor-container">
        <div className="rb-fund-editor-input-container">
          <div className="rb-fund-editor-recurring-amount">
            <RetailContributionsEditor {...props} />
            <If test={isIRA(fund)}>
              <div className="rb-fund-editor-contribution-info-container">
                <a
                  className="rb-fund-editor-contribution-info-link"
                  onClick={showIRAContributions}
                >
                  <div className="rb-fund-editor-contribution-info-text">
                    {' '}
                    View Contribution Table
                  </div>
                </a>
              </div>
            </If>
            {isRAS(fund.productType) && (
              <div className="rb-fund-editor-deposits-info-container">
                <div className="rb-fund-editor-deposits-info-text">
                  <DepositsInformationTooltip
                    labelSubText=""
                    labelText="How do we handle deposits?"
                    tipHeader="How do we handle deposits?"
                    tipMessage={
                      <div>
                        When you add money to your Retirement Advisory Service
                        account(s), those assets will be held as cash until the
                        next automatic rebalancing of your accounts occurs to
                        keep your advisory accounts aligned with your
                        Recommended Portfolio.
                      </div>
                    }
                  />
                </div>
              </div>
            )}
          </div>
          <div className="rb-fund-editor-frequency-container">{MonthGrid}</div>
          <div className="rb-fund-editor-date-container">{DayGrid}</div>
        </div>
        <If test={isIRA(fund)}>
          <div className="rb-fund-editor-retirement-note-container">
            <If test={isIRA(fund)}>
              <div className="rb-fund-editor-retirement-note">
                <span className="rb-fund-editor-title">Note: </span>
                Automatic IRA contributions cannot be attributed to the prior
                year.
              </div>
            </If>
          </div>
        </If>
      </div>
    </Fragment>
  );
};

export default RecurringBuyFundEditorWrapper;
